import React, { useEffect, useState } from 'react';

import styles from './selectPlantPortal.module.css';
import { KTSVG, toAbsoluteUrl } from '../../../../../../_metronic/helpers';
import { SearchInputV2 } from '../../../SearchInputV2';
import { LoadingSpan } from '../../../Loadings/loadingSpan';
import { ModalDeletePlant } from '../../../../dashboard/TablePlants/components/ModalDeletePlant';
import { ModalUnlinkPlant } from '../../../../dashboard/TablePlants/components/ModalUnlinkPlant';
import { Plants } from '../../../../../@types/plants';
import { ModalAddSimplePlantsToComposite } from '../ModalAddSimplePlantsToComposite';
import { useAuth } from '../../../../../modules/auth';


type Props = {
    itens: any[] | undefined;
    buttonAll: boolean;
    value: string | number;
    textSearch?: string | null;
    textButtonInit?: string | null;
    typeIcon?: "img" | "svg" | "icon" | "badge";
    linkIcon?: string;
    sizeIconSvg?: string;

    badgeColor?: string; 
    badgeText?: string; 
    badgeKey?: string;  
    colorsBadge?: Record<string, string>; 
    imageSize?: string;

    onChange: (value: string) => void;
    labelKey: string;
    valueKey: string;
    className?: any;
    setPagination?: any;
    loading?: boolean;
    style?: any
    refresh: () => void
}

export function SelectPlantPortal({
    itens, 
    buttonAll,  
    value,
    textSearch,
    textButtonInit,
    onChange,
    labelKey,
    valueKey,
    className,
    typeIcon,
    linkIcon,
    sizeIconSvg,
    setPagination,
    loading,
    badgeColor,
    badgeText,
    badgeKey,
    colorsBadge,
    style,
    imageSize,
    refresh
}: Props) {
    // const [filterLabel, setFilterLabel] = useState<{
    //     linkIcon?: string | null, 
    //     value: string | number, 
    //     label: string, 
    //     badgeColor?: string | null, 
    //     badgeText?: string } | null
    // >({
    //     linkIcon: null, 
    //     value: value, 
    //     label: itens && itens.length > 0 
    //         ? itens.find((item: any) => item[valueKey] === value)?.[labelKey] || "" 
    //         : "",
    //      badgeColor: badgeColor ? badgeColor : null
    // });

      const [showCreateAppModalDeleteV2, setShowCreateAppModalDeleteV2] = useState<boolean>(false);
        const [myPlantObjectDelete, setMyPlantObjectDelete] = useState<Plants | null>(null);
      const [showModalAddSimplePlants, setShowModalAddSimplePlants] = useState<boolean>(false);
      const [showModalUnlinkPlant, setShowModalUnlinkPlant] = useState<boolean>(false);
      const [myPlantObjectUnlink, setMyPlantObjectUnlink] = useState<Plants | null>(null);
      const { currentUser } = useAuth();

    const [filterLabel, setFilterLabel] = useState<{
        linkIcon?: string | null,
        value: string | number,
        label: string,
        badgeColor?: string | null,
        badgeText?: string
      } | null>(() => {
        if (itens && itens.length > 0 && value !== "") {
          const selectedItem = itens.find((item: any) => item[valueKey] === value);
      
          if (selectedItem) {
            const badgeTextFromItem = badgeKey ? selectedItem[badgeKey] : "";
            const badgeColorFromItem =
              colorsBadge && badgeTextFromItem
                ? colorsBadge[badgeTextFromItem] || "primary"
                : badgeColor || null;
      
            return {
              linkIcon: selectedItem.credential?.mark?.link_imagem || null,
              value: selectedItem[valueKey],
              label: selectedItem[labelKey] || "",
              badgeColor: badgeColorFromItem,
              badgeText: badgeTextFromItem
            };
          }
        }
      
        return {
          linkIcon: null,
          value: value,
          label: "",
          badgeColor: badgeColor ? badgeColor : null,
          badgeText: badgeText ? badgeText : ""
        };
      });

    const [mySearch, setMySearch] = useState<any[]>([]);
    const [control, setControl] = useState<boolean>(false);

    function handleChange(filterLabel: any, myOnChange: any) {
        
        setFilterLabel(filterLabel);
        onChange(myOnChange);

        if(setPagination !== undefined){
            setPagination((prev) => ({
                ...prev,
                page: 1
            })); 
        }
    }

    // useEffect(() => {
    //     if(value === ""){
    //         setFilterLabel({
    //             linkIcon: null, 
    //             value: value, 
    //             label: itens && itens.length > 0 
    //                 ? itens.find((item: any) => item[valueKey] === value)?.[labelKey] || "" 
    //                 : "",
    //             badgeColor: badgeColor ? badgeColor : null,
    //             badgeText: itens && itens.length > 0 
    //             ? itens.find((item: any) => item[valueKey] === value)?.[labelKey] || "" 
    //             : "",
    //         })
    //     }
    // }, [value])

    useEffect(() => {
        if (itens && itens.length > 0) {
          const selectedItem = itens.find((item: any) => item[valueKey] === value);
      
          if (selectedItem) {
            const badgeTextFromItem = badgeKey ? selectedItem[badgeKey] : "";
            const badgeColorFromItem =
              colorsBadge && badgeTextFromItem
                ? colorsBadge[badgeTextFromItem] || "primary"
                : badgeColor || null;
      
            setFilterLabel({
              linkIcon: selectedItem.credential?.mark?.link_imagem || "https://res.cloudinary.com/deq3ehxe3/image/upload/v1735238752/plant2_tuwshh.png",
              value: selectedItem[valueKey],
              label: selectedItem[labelKey] || "",
              badgeColor: badgeColorFromItem,
              badgeText: badgeTextFromItem
            });
          }
        }
      }, [value, itens, badgeKey, colorsBadge, badgeColor]);

    return (
        <div className={className ? className : ''} style={style ? style : {}}>
            <div className={`me-0 dropdown ${styles.divGlobalSelect}`} style={{ position: 'relative' }}>
                <button
                    className={`btn btn-lg btn-light ${styles.buttonMainSelect}`}
                    type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"
                >
                    <span className={styles.spanButtonMainSelectV2}>
                        {
                            typeIcon === "icon" ?
                                <i className={`${linkIcon ? linkIcon : ""} fs-5`}></i>
                            : typeIcon === "img" ?
                                filterLabel && filterLabel.linkIcon ?
                                    <div className={`symbol symbol-${imageSize ? imageSize : "25px"} ${styles.divImgButtonSelect}`}>
                                        <img 
                                            src={toAbsoluteUrl(
                                                linkIcon ? linkIcon : filterLabel 
                                                && filterLabel.linkIcon 
                                                ? filterLabel && filterLabel.linkIcon : "https://res.cloudinary.com/deq3ehxe3/image/upload/v1735238752/plant2_tuwshh.png"
                                            )} 
                                            className='' 
                                            alt='' 
                                        />
                                    </div>
                                :
                                    linkIcon ?
                                        <div className={`symbol symbol-${imageSize ? imageSize : "20px"} ${styles.divImgButtonSelect}`}>
                                            <img 
                                                src={toAbsoluteUrl(
                                                    linkIcon ? linkIcon : ""
                                                )} 
                                                className='' 
                                                alt='' 
                                            />
                                        </div>
                                    :
                                    <></>
                            : typeIcon === "svg" ?
                                <KTSVG 
                                    path={linkIcon ? linkIcon : ""} 
                                    className={`svg-icon-muted svg-icon-${sizeIconSvg ? sizeIconSvg : "3x"} ms-n1`} 
                                />
                            : typeIcon === "badge" && filterLabel && filterLabel.badgeColor ?
                                <span 
                                    className={`badge badge-${filterLabel.badgeColor} fs-9`}
                                    style={{height: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                                >
                                    {filterLabel.badgeText ? filterLabel.badgeText : ''}
                                </span>
                            :
                            <></> 
                        }
                        <span className={`${styles.spanButtonMainSelect}`}>
                            {filterLabel && filterLabel.label !== "" ? filterLabel.label : textButtonInit ? textButtonInit : "Selecione uma opção"} 
                        </span>
                    </span>
                    {
                        loading && loading === true ?
                            <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                        :
                            <i className="bi bi-caret-down-fill fs-7"></i>
                    }

                </button>

                <div 
                    className={`dropdown-menu dropdown-menu-end border border-1 border-light ${styles.divOptionsSelectV1} ${className ? className : ''}`} 
                    aria-labelledby="dropdownMenuButton1"
                    style={{
                        position: 'absolute',
                        zIndex: 1050
                    }}
                >
                    <div className={`card-toolbar nav nav-tabs ${styles.divOptionsSelectV2}`} data-kt-buttons='true'>
                        <div className={styles.divSearchSelect}>
                            <SearchInputV2
                                className='form-control form-control-sm bg-light'
                                placeholder={textSearch ? textSearch : "Buscar"}
                                myDate={itens}
                                setMySearch={setMySearch}
                                control={control}
                                style={{ width: '100%' }}
                                setControl={setControl}
                                searchParameter={labelKey}
                                disabled={loading ? loading : false}
                            />
                        </div>
                        <div className={styles.divOptionsSelectV3}>
                            {buttonAll && (
                                <button
                                    className={`btn btn-sm btn-color-muted btn-active btn-active-primary bg-hover-light ${filterLabel && filterLabel.value === "" ? "active" : "text-hover-primary"} px-5 ${styles.buttonAllSelect}`}
                                    data-bs-toggle="tab"
                                    disabled={loading ? loading : false}
                                    onClick={() => {

                                        handleChange(null, "")
                                        // setFilterLabel(null);
                                        // onChange("");
                                    }}
                                >
                                    <span style={{ textAlign: 'start' }}>
                                        Todos
                                    </span>
                                </button>
                            )}
                            
                            {loading ?
                                <div style={{width: '100%', display: 'flex', justifyContent: 'center', marginTop: '1rem', marginBottom: '1rem'}}>
                                    <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                                </div>
                            :
                            (control ? mySearch : itens)?.map((item: any) => {
                                // texto e cor da badge
                                const badgeTextFromItem = badgeKey ? item[badgeKey] : "";
                                const badgeColorFromItem = colorsBadge && badgeTextFromItem
                                    ? colorsBadge[badgeTextFromItem] || "primary"
                                    : "primary";
                            

                                return (
                                    <button
                                        key={item[valueKey]}
                                        className={`btn btn-sm btn-color-muted btn-active btn-active-primary bg-hover-light ${styles.buttonAllSelect} ${filterLabel && filterLabel.value === item[valueKey] ? "active" : "text-hover-primary"} px-5`}
                                        data-bs-toggle="tab"
                                        onClick={() => {
                                            handleChange(
                                                { 
                                                    linkIcon: item.link_imagem ? item.link_imagem : "" , 
                                                    value: item[valueKey], 
                                                    label: item[labelKey] || "",
                                                    badgeColor: badgeColorFromItem,
                                                    badgeText: badgeTextFromItem
                                                }, 
                                                item[valueKey]
                                            )
                                        }}
                                    >
                                        <span
                                            className={`bullet bullet-vertical h-30px bg-${
                                            item.status !== null
                                                ? item.status === 0
                                                ? "success"
                                                : item.status === 1
                                                ? "danger"
                                                : item.status === 2
                                                ? "warning"
                                                : item.status === 7 || item.status === 3
                                                ? "info"
                                                : "secondary"
                                            : "secondary"
                                            } ${styles.spanMarcador}`}
                                        />
                                        
                                        {typeIcon === "img" ? (
                                            <div 
                                                className={`symbol symbol-${imageSize ? imageSize : "25px"} ${styles.divImgButtonSelect}`}
                                                title={item.credential?.mark?.name ? item.credential?.mark?.name : ""}
                                                style={{cursor: 'pointer'}}
                                            >
                                                <img 
                                                    src={toAbsoluteUrl(linkIcon ? linkIcon : item.credential?.mark?.link_imagem ? item.credential?.mark?.link_imagem : "https://res.cloudinary.com/deq3ehxe3/image/upload/v1735238752/plant2_tuwshh.png")} 
                                                    alt='' 
                                                />
                                            </div>
                                        ) : typeIcon === "svg" ? (
                                            <KTSVG 
                                                path={linkIcon ? linkIcon : ""} 
                                                className={`svg-icon-muted svg-icon-${sizeIconSvg ? sizeIconSvg : "3x"} ms-n1`} 
                                            />
                                        ) : typeIcon === "icon" ? (
                                            <i className={`${linkIcon ? linkIcon : ""} fs-5`}></i>
                                        ) : <></>}
                                        
                                        <span className={styles.spanButtonSelectedSelect}>
                                            {item[labelKey] || "Não identificado"}
                                        </span>

                                        {
                                            typeIcon === "badge" && (
                                                <span 
                                                    className={`badge badge-${badgeColorFromItem} fs-9`}
                                                    style={{height: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                                                >
                                                    {badgeTextFromItem}
                                                </span>
                                            ) 
                                        }

                                        {currentUser?.role.slug !== "CLIENTE" && 
                                        <div className='d-flex gap-2'>
                                            {item.type_plant !== "COMPOSTA" && item[valueKey] !== value &&  
                                                <button
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        setMyPlantObjectDelete(item)
                                                        setShowCreateAppModalDeleteV2(true)
                                                    }}
                                                >
                                                    <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                                                </button>    
                                            }

                                            {item.type_plant !== "COMPOSTA" && item[valueKey] !== value &&  
                                                <button
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        setMyPlantObjectUnlink(item)
                                                        setShowModalUnlinkPlant(true)
                                                    }}
                                                >   
                                                    <i className="fas fa-unlink fs-5"></i>
                                                </button>    
                                            }
                                        </div>}
                                    </button>
                                );
                            })}
                        </div>
                        {currentUser?.role.slug !== "CLIENTE" && <div className='d-flex justify-content-end px-5 py-3 border-top w-100'>
                            {value && itens && itens.length > 0 && (() => {
                                const selectedItem = itens.find((item: any) => item[valueKey] === value);
                                const isComposite = selectedItem?.type_plant === "COMPOSTA";
                                
                                if (isComposite) {
                                    return (
                                        <button
                                            type='button'
                                            className='btn btn-sm btn-light-primary btn-active-primary w-100'
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setShowModalAddSimplePlants(true);
                                            }}
                                        >
                                            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3 me-2' />
                                            Adicionar usina SIMPLES
                                        </button>
                                    );
                                }
                                return null;
                            })()}
                        </div>}
                    </div>
                </div>
            </div>

            <ModalDeletePlant 
                show={showCreateAppModalDeleteV2}
                data={myPlantObjectDelete}
                id={myPlantObjectDelete ? myPlantObjectDelete.id : undefined} 
                handleClose={() => {
                    setMyPlantObjectDelete(null)
                    setShowCreateAppModalDeleteV2(false)
                    refresh()
                }} 
            />

            <ModalAddSimplePlantsToComposite
                show={showModalAddSimplePlants}
                handleClose={() => {
                    setShowModalAddSimplePlants(false);
                }}
                idPlantComposite={value ? String(value) : null}
                refresh={refresh}
            />

            {(() => {
                // Encontrar o id da usina composta (primeiro item com type_plant === "COMPOSTA")
                const compositePlant = itens?.find((item: any) => item.type_plant === "COMPOSTA");
                const idPlantComposite = compositePlant ? compositePlant[valueKey] : null;
                
                return (
                    <ModalUnlinkPlant
                        show={showModalUnlinkPlant}
                        data={myPlantObjectUnlink}
                        idPlantComposite={idPlantComposite ? String(idPlantComposite) : null}
                        idPlantSimple={myPlantObjectUnlink ? String(myPlantObjectUnlink[valueKey]) : null}
                        handleClose={() => {
                            setMyPlantObjectUnlink(null)
                            setShowModalUnlinkPlant(false)
                            refresh()
                        }}
                    />
                );
            })()}
        </div>
    );
}
